import type { SerializedStyles } from '@emotion/react';
import type { HTMLAttributes, ReactNode } from 'react';
import type { EmptyOverlayProps } from '..';

export interface SelectOption<TValue = string> {
  value: TValue;
  label?: ReactNode;
  iconRight?: ReactNode;
  iconLeft?: ReactNode;
  ignoreSearch?: boolean;
  searchValues?: string[];
}

export interface DropdownSelectSearchProps<TValue>
  extends Omit<HTMLAttributes<HTMLInputElement>, 'onSelect'> {
  wrapperProps?: HTMLAttributes<HTMLDivElement>;
  wrapperCss?: SerializedStyles;

  multiple?: boolean;
  value?: TValue[] | TValue;
  onSelect?: (selected: SelectOption<TValue>, fieldValue?: TValue | TValue[]) => void;
  options?: SelectOption<TValue>[];

  search?: string;

  inputProps?: HTMLAttributes<HTMLInputElement>;
  hideSearchInput?: boolean;
  noEmpty?: boolean;

  loading?: boolean;
  showEmptyMessage?: boolean;
  emptyProps?: EmptyOverlayProps;
}
